import { render, staticRenderFns } from "./TransferItem.vue?vue&type=template&id=01342320"
import script from "./TransferItem.vue?vue&type=script&lang=ts"
export * from "./TransferItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports